<div class="rectangle" [style.height.px]="height"></div>